<script>
import Layout from '@layouts/main'

import {AxiosHelper} from '@src/utils/utils';

export default {
	components: { Layout, },
  data() {
    return {
			title: '품목내역',
			category : [],
			list : [],
			groups : [],
			isLife : true,
			selectedCategory : 0,
			selectedGroup1 : '',
			selectedGroup2 : '',
			listGroup2 : [],
    }
	},
	mounted() {
		AxiosHelper.get('/api/cardsms/group/kind').then(ret => {
			this.category = ret.data;
		});

		AxiosHelper.get(`/api/cardsms/pay/category/0`).then(ret => {
			const groups = [];
			let beforeCate = '';
			for(const payDetail of ret.data) {
				if(!groups[payDetail.group1]) {
					groups[payDetail.group1] = [];
				}

				if(beforeCate !== payDetail.group2)
					groups[payDetail.group1].push(payDetail.group2);
				beforeCate = payDetail.group2;
			}

			this.groups = groups;
		});
		this.getItemList();
	},
	methods : {
		changeCategory : function() {
			if(this.selectedCategory === 0) {
				this.isLife = true;
			}
			else {
				this.isLife = false;
				this.selectedGroup1 = '';
				this.selectedGroup2 = '';
			}

			this.getItemList();
		},

		changeGroup1 : function() {
			const group2 = {};
			this.groups[this.selectedGroup1].forEach(elem => {
			if(!group2[elem])
				group2[elem] = elem;

			});
		
			this.listGroup2 = Object.keys(group2);
			this.selectedGroup2 = '';
			this.getItemList();
		},

		changeGroup2 : function() {
			this.getItemList();
		},

		getItemList : function() {
			let url = `/api/cardsms/pay/category/${this.selectedCategory}`;

			if(this.selectedGroup1) {
				url += `/${encodeURIComponent(this.selectedGroup1)}`;
			}
			if(this.selectedGroup2) {
				url += `/${encodeURIComponent(this.selectedGroup2)}`;
			}
			
			AxiosHelper.get(url).then(ret => {
				this.list = ret.data;
			});
		},


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader :title="title" />
    <C.Row>
			<C.Col lg="12">
        <C.Card>
					<C.CardBody>
          <h4 class="header-title">가계부에 등록한 생활비 내역</h4>
					<div class="form-row">
						<div class="form-group col-md-4">
							<label class="col-form-label">대분류</label>
							<select v-model="selectedCategory" class="form-control" @change="changeCategory">
								<option v-for="(cate) in category" :key="cate.idx" :value="cate.idx">{{cate.cate_name}}</option>
							</select>
						</div>
						<div class="form-group col-md-4">
							<label class="col-form-label">중분류</label>
							<select v-model="selectedGroup1" class="form-control" :disabled="isLife === false" @change="changeGroup1">
								<option value=''>전체선택</option>
								<option v-for="group in Object.keys(groups)" :key="group" :value="group">{{group}}</option>
							</select>
						</div>
						<div class="form-group col-md-4">
							<label class="col-form-label">소분류</label>
							<select v-model="selectedGroup2" class="form-control" :disabled="isLife === false" @change="changeGroup2">
								<option value=''>전체선택</option>
								<option v-for="group in listGroup2" :key="group" :value="group">{{group}}</option>
							</select>
						</div>
					</div>
					
          <div class="table-responsive">
            <table class="table table-sm table-striped mb-0">
              <thead>
                <tr>
									<th>구매일</th>
									<th>중분류</th>
									<th>소분류</th>
									<th>상품명</th>
									<th>가격</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.idx">
                  <th scope="row">{{item.time}}</th>
                  <td>{{item.group1}}</td>
                  <td>{{item.group2}}</td>
                  <td>{{item.detail_name}}</td>
									<td>{{item.price}}</td>
                </tr>
              </tbody>
            </table>
          </div>
					</C.CardBody>
        </C.Card>
        <!-- end card-box -->
			</C.Col>
      <!-- end col -->

    </C.Row>
    <!--- end row -->

  </Layout>
</template>